module.exports = __webpack_public_path__ + "img/titleD.17d68ce1.png";